import { translator } from "../../../../../shop/frontend/web/js/services/TranslatorService";
import { EventFilter } from "../../../../../shop/frontend/web/js/components/EventFilter";
import { EventFrontendFilterModel } from "../models/EventFrontendFilterModel";
import { DatePickerComponent } from "../../../../../shop/frontend/web/js/components/DatePickerComponent";
import { EventEmitter } from "../../../../../shop/frontend/web/js/components/EventEmitter";
import { checkLongText } from "../components/longText";

class SiteController {
	constructor() {
		this.emitter = new EventEmitter();

		/* Объявляем переменные для фильтра */
		this.eventFilter = new EventFilter();
		this.filterModel = new EventFrontendFilterModel();

		/**
		 * Будет включать в себя компонент для работы с датой фильтра
		 * @module DatePickerComponent
		 */
		this.datePicker = null;
	}

	init() {
		translator.getLanguages().then(() => {
			this.setUpSubscribers();
			this.setUpListeners();

			this.initMainFilter();
			this.initMainCalendar();

			this.initToTopScrolling();

			checkLongText();
		});
	}

	setUpSubscribers() {
		/**
		 * Подписчик который применяет фильтр на афише
		 * делает запрос на сервер и возвращает res {Object} - {eventsCount, page, html}
		 * @event SiteController#event:apply-filter
		 */
		this.emitter.subscribe("event:apply-filter", (params = {}) => {
			this.setNoms();
			/* по умолчанию сбрасываем пагинацию страниц */
			if (params.needResetPage !== false) this.filterModel.page = 0;

			return this.filterModel.search(this.filterModel.getSearchParams()).then(res => {
				this.eventFilter.showFilteredEvents({
					...res,
					hasAnyAppliedParam: this.filterModel.hasAnyAppliedParam(),
					limit: this.filterModel.limit,
				});

				checkLongText();
			});
		});
	}

	setUpListeners() {
		$(".js-dropdown-filter-reset").on("click", e => {
      const element = $(e.currentTarget);
			$(".js-dropdown-filter input[type=radio]").prop("checked", false);
			this.filterModel.dateRange = null;
			const previousText = $(".js-dropdown-filter .dropdown__btn ").data("previous");
			element.parent('.js-dropdown-filter').find('.filter__selected-text').text(previousText);
		});

		$(".js-dropdown-filter input[type=checkbox]").on("change", e => {
			const element = $(e.currentTarget);
			if (element.is(":checked")) {
				element.addClass("active");
        		element.find('.filter__selected-text').text(element.val());
			} else {
				element.removeClass("active");
				const previousText = $(".js-dropdown-filter .dropdown__btn ").data("previous");
				element.find('.filter__selected-text').text(previousText);
			}
			const selected = [];
			$(".js-dropdown-filter input[type=checkbox]").each((i, item) => {
				if ($(item).is(":checked") && $(item).data('first')) {
					const firstDate = $(item).data("first");
					const secondDate = $(item).data("last");
					selected.push({ firstDate, secondDate });
				}
			});
			if (selected.length) {
				const firstDate = selected[0].firstDate;
				const secondDate = selected[selected.length - 1].secondDate;
				this.filterModel.setDateRange(firstDate, secondDate);
			} else {
				this.filterModel.dateRange = null;
			}
		});

		$(".js-type-filter input[type=checkbox][data-nom-ids]").on("change", e => {
			const element = $(e.currentTarget);
			this.setFilterToType(element);
		});

		$(".js-type-filter input[type=checkbox][data-unit-ids]").on("change", e => {
			const element = $(e.currentTarget);
			this.setFilterToObjects(element);
		});

		$(".js-type-filter-reset").on("click", () => {
			$(".js-type-filter input[type=checkbox]").prop("checked", false);
			$(".js-type-filter .filter__selected-text").text(
				$(".js-type-filter .dropdown__btn").data("previous")
			);
			this.filterModel.removeItemsByType("nomIds");
			return this.emitter.emit("event:apply-filter");
		});
	}

	initMainFilter() {
		if ($("#js-filter").attr("data-limit"))
			this.filterModel.limit = parseInt($("#js-filter").attr("data-limit"));

		/* Инициализация фильтрации по типам мероприятии (Матчи, Абонементы...) */
		this.eventFilter.initDropdownTypes();

		/* Инициализация чекбокс параметров фильтра в выпадающем списке */
		this.eventFilter.initDropdownFilters();
		this.eventFilter.on("change-dropdown-input", checkboxData => {
			if (checkboxData.isChecked) {
				this.filterModel.addItem(checkboxData);
			} else {
				this.filterModel.removeItem(checkboxData);
			}

			return this.emitter.emit("event:apply-filter");
		});

		/* Инициализация мобильного фильтра даты */
		this.eventFilter.on("setup-date-range", ({ firstDate, secondDate }) => {
			this.filterModel.setDateRange(firstDate, secondDate);
			return this.emitter.emit("event:apply-filter");
		});

		this.eventFilter.on("clear-date-range", () => {
			this.filterModel.dateRange = null;
			return this.emitter.emit("event:apply-filter");
		});

		this.eventFilter.on("reset-dropdown-filter", type => {
			this.filterModel.removeItemsByType(type);

			return this.emitter.emit("event:apply-filter");
		});

		this.eventFilter.on("click-load-more", () => {
			this.filterModel.setNextPage();

			return this.emitter.emit("event:apply-filter", { needResetPage: false });
		});

		/**
		 * Обработчик который сбрасывает фильтр
		 * @event SiteController#event:clear-filter
		 */
		this.eventFilter.on('clear-filter', () => {
			this.filterModel.clear();
			$('.js-dropdown-filter input[type=radio]').prop('checked', false);
			$('.js-type-filter input[type=checkbox]').prop('checked', false);
			$('.js-dropdown-filter .dropdown__btn').each(() => {
				$('.js-dropdown-filter .filter__selected-text').text($(this).data('previous'));
			});
			$('.js-type-filter .dropdown__btn').each(function () {
				$('.js-type-filter .filter__selected-text').text($(this).data('previous'));
			});
			return this.emitter.emit('event:apply-filter');
		});
	}

	setNoms() {
		const addNoms = noms => {
			var arr = JSON.parse(noms);
			arr.forEach(el => {
				this.filterModel.addItem({ type: "nomIds", id: el });
			});
		};

		if (window.location.pathname.includes("site/tram")) {
			addNoms(window.nomsTram);
		}

		if (window.location.pathname.includes("site/online")) {
			addNoms(window.nomsOnline);
		}
	}

	setFilterToObjects() {
		this.filterModel.removeItemsByType("unit");
		$(".js-type-filter input[type=checkbox][data-unit-ids]").each((i, item) => {
			if ($(item).is(":checked")) {
				const unitIds = Array.from($(item).data("unit-ids"));
				unitIds.forEach(el => {
					this.filterModel.addItem({ type: "unit", id: el });
				});
			}
		});

		return this.emitter.emit("event:apply-filter");
	}

	setFilterToType(element) {
		this.filterModel.removeItemsByType("nomIds");
		let count = 0;

		$(".js-type-filter input[type=checkbox][data-nom-ids]").each((i, item) => {
			if ($(item).is(":checked")) {
				count++;
				if ($(item).val() === "online") {
					$(item).prop("checked", false);
					count--;
				}
				if ($(item).val() === "ordinary") {
					const excluded = [];

					$(".js-type-filter input[type=checkbox][data-nom-ids]").each((j, el) => {
						if (!$(el).is(":checked") && $(el).val() !== "ordinary") {
							const nomIds = Array.from($(el).data("nom-ids"));
							nomIds.forEach(e => {
								excluded.push(e);
							});
						}
					});
					const nomIds = Array.from($(item).data("nom-ids"));
					nomIds.forEach(el => {
						if (!excluded.includes(el)) {
							this.filterModel.addItem({ type: "nomIds", id: el });
						}
					});
				} else {
					const nomIds = Array.from($(item).data("nom-ids"));
					nomIds.forEach(el => {
						this.filterModel.addItem({ type: "nomIds", id: el });
					});
				}
			}
		});

		const dropdownBtn = $(".js-type-filter .dropdown__btn");

		if (count) {
			$(".js-type-filter .filter__selected-text").text(
				`${dropdownBtn.data("text")} ${count}`
			);
		} else {
			$(".js-type-filter .filter__selected-text").text(dropdownBtn.data("previous"));
		}
		if ($('.js-type-filter input[type=checkbox][data-type="subscription"]').is("checked")) {
			this.filterModel.addItem({ type: "all", select: value, id: value });
		} else {
			this.filterModel.removeItemsByType("all");
		}

		return this.emitter.emit("event:apply-filter");
	}

	initMainCalendar() {
		this.datePicker = new DatePickerComponent($(".js-datepicker-filter"));

		this.datePicker.on("apply", (ev, picker) => {
			const formatStart = picker.startDate.format("DD-MM-YYYY");
			const formatEnd = picker.endDate.format("DD-MM-YYYY");

			this.filterModel.setDateRange(formatStart, formatEnd);

			return this.emitter.emit("event:apply-filter");
		});

		/* Обработчик который сбрасывает календарь */
		this.datePicker.on("cancel", () => {
			this.filterModel.dateRange = null;
			this.datePicker.reset();

			return this.emitter.emit("event:apply-filter");
		});
	}

	initToTopScrolling() {
		const items = $("#js-index");

		if (!items.length) return false;

		const eventTop = $(".js-to-top");
		let needCorrect = 150;
		const top = items.offset().top - needCorrect;
		const screenHeight = window.screen.height;

		eventTop.on("click", () => {
			$("body")[0].scrollTo({
				top,
				behavior: "smooth",
			});

			eventTop.removeClass("active");
		});

		$("body").on("scroll", () => {
			if ($("body").scrollTop() > screenHeight / 2) {
				eventTop.addClass("active");
			} else {
				eventTop.removeClass("active");
			}
		});
	}
}

const siteController = new SiteController();
siteController.init();
